var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { EditService } from 'app/services/edit.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService } from 'app/services/domain.service';
import { UserService } from 'app/services/user.service';
import { ActivityService } from 'app/services/activity.service';
import { MainDataService } from 'app/services/main-data.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { ToastrService } from 'ngx-toastr';
var EditCardComponent = /** @class */ (function () {
    function EditCardComponent(toastr, activityService, attrIndexService, domainService, editService, mainDataService, mapService, mapLayerService, userService) {
        this.toastr = toastr;
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.domainService = domainService;
        this.editService = editService;
        this.mainDataService = mainDataService;
        this.mapService = mapService;
        this.mapLayerService = mapLayerService;
        this.userService = userService;
        this.selectionList = [];
        this.editRecordList = [];
        this.commitDisableReason = ''; // TODO
        // neighborOption = 'get_neighbor';
        // @Output() edit: EventEmitter<EditDataEmitter> = new EventEmitter();
        this.clickDiscard = new EventEmitter();
        this.clickCommit = new EventEmitter();
        this.clickAdd = new EventEmitter();
    }
    EditCardComponent.prototype.onChange = function (col, isOnlyGeomChange, isDeleteChange, isStateOrCountyCol) {
        return __awaiter(this, void 0, void 0, function () {
            var cateCode, triggeredChanges;
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.selectedRecord) {
                    return [2 /*return*/];
                }
                cateCode = this.activityService.selectedLayerBS.getValue().layer.category.code;
                // const data: EditDataEmitter = {
                // 	recId: this.getRecordId(this.selectedRecord),
                // 	card: this.selectedRecord,
                // 	changedCol: col ? col.prop : null
                // 	// deleteStatusChange: deleteStatusChange
                // }
                // if (isDeleteChange) {
                // 	data.changedCol = this.toDeleteCol;
                // }
                if (!this.selectedRecord[this.isEditedCol]) {
                    if (!this.selectedRecord[this.isEditedCol]) {
                        this.mainDataService.addRecToCard(this.getRecordId(this.selectedRecord), null, 'card');
                    }
                    // this.addCardToList(this.selectedRecord);
                    // data.isInitEdit = true;
                }
                if (col && !isOnlyGeomChange) {
                    if (this.domainsByColumn[col.prop] && this.domainsByColumn[col.prop].type === 'list') {
                        this.domainService.updateDependentDomains(this.domainsByColumn, {
                            prop: col.prop,
                            standardName: col.info.standardColName
                        }, this.selectedRecord, cateCode);
                    }
                    // if (isStateOrCountyCol && col.info.standardColName === this.stateColStandard) {
                    // 	if () {
                    // 	}
                    // } else {
                    // 	this.editCardService.updateDependentDomains(this.selectedRecord, this.columns, col);
                    // }	
                }
                triggeredChanges = this.editService.editTrigger(cateCode, this.selectedRecord, col.prop, this.selectedRecord[col.prop]);
                Object.keys(triggeredChanges).forEach(function (i) {
                    _this.selectedRecord[i] = triggeredChanges[i];
                });
                if (col && col.isAnchored) {
                    this.updateListToAnchoredValue(col);
                }
                return [2 /*return*/];
            });
        });
    };
    // 	async onChangeStateOrCounty(col: EditCardColumn, newValue, selectEl: HTMLSelectElement) {
    // // 		if (newValue === this.neighborOption) {
    // // // TODO
    // // 			const neighbors = await this.domainService.getNagNeighbors(this.userService.customerInfo.givState, this.userService.customerInfo.cusCounties[0])
    // // 			col.info.neighborList = neighbors;
    // // 			// console.log(selectEl)
    // // 			// debugger
    // // 			// selectEl.value = this.selectedRecord[col.prop];
    // // 			setTimeout(() => {
    // // 				selectEl.selectedIndex = neighbors.indexOf(this.selectedRecord[col.prop]);
    // // 			});
    // // 			return;
    // // 		}
    // // 		this.selectedRecord[col.prop] = newValue;
    // // 		this.onChange(col, null, null, true);
    // 	}
    EditCardComponent.prototype.onChangeDelete = function (isDelete) {
        if (this.selectedRecord[this.isNewKey]) {
            var id = this.getRecordId(this.selectedRecord);
            this.mainDataService.removeDataFromStoredRecords(id);
            var editedIds = this.activityService.editRecordListBS.getValue().ids;
            editedIds.splice(editedIds.indexOf(id), 1);
            this.activityService.editRecordListBS.next({
                ids: editedIds,
                source: 'card'
            });
        }
        else {
            this.selectedRecord[this.toDeleteCol] = isDelete;
            this.onChange(null, null, true);
        }
    };
    EditCardComponent.prototype.checkValueInDomain = function (col) {
        if (!this.selectedRecord[col.prop] && this.selectedRecord[col.prop] !== 0) {
            return;
        }
        var domain = this.domainsByColumn[col.prop];
        if (domain && domain.type === 'list') {
            if (!domain.list) {
                return;
            }
            var idx = domain.list.indexOf(this.selectedRecord[col.prop]);
            if (idx < 0 && col.info.neighborList) {
                idx = col.info.neighborList.indexOf(this.selectedRecord[col.prop]);
            }
            if (idx < 0) {
                return false;
            }
            else {
                return true;
            }
        }
    };
    EditCardComponent.prototype.checkCellEditDisable = function (col) {
        if (col.info.isEditDisabled || this.selectedRecord[this.toDeleteCol] || this.disableEditing) {
            return true;
        }
    };
    //
    // private addCardToList(rec) {
    // 	if (!rec[this.isEditedCol]) {
    // 		// rec[this.isEditedCol] = true;
    // 		// this.editRecordList.push(rec);
    // 		this.mainDataService.addRecToCard(this.getRecordId(rec), null, 'card');
    // 			// // Store the original data
    // 			// this.editService.originRecordList.push(origin);
    // 		// // Trigger change
    // 		// this.onEditRecordListChange.emit({
    // 		// 	editList: this.editRecordList
    // 		// });
    // 	}
    // }
    EditCardComponent.prototype.changeSelectedRecord = function (recId, skipTrigger) {
        this.currentCardId = recId;
        if (recId) {
            this.selectedRecord = this.mainDataService.getDataAttrs(recId);
        }
        else {
            this.selectedRecord = null;
        }
        // Check show carryAttr tool
        this.checkCarryAttrTool();
        //
        if (this.selectedRecord) {
            // Get domains
            var layerCate_1 = this.activityService.selectedLayerBS.getValue().layer.category;
            var cols = this.columns.map(function (c) {
                return {
                    prop: c.prop,
                    standard: layerCate_1.standardCols.find(function (s) { return s.colName === c.info.standardColName; })
                };
            });
            this.domainsByColumn = this.domainService.getColumnDomains(cols, layerCate_1.code, this.selectedRecord);
        }
        if (!skipTrigger) {
            this.activityService.currentCardBS.next({
                id: recId,
                source: 'card'
            });
        }
        //
        // if (!skipTrigger) {
        // 	this.selectRecord.emit({
        // 		id: recId
        // 	});
        // }
    };
    EditCardComponent.prototype.checkCommitDisabled = function () {
        return this.displayMode !== 'edit' || !this.editRecordList.length;
    };
    EditCardComponent.prototype.goPrevRecord = function () {
        var idx = this.currentList.indexOf(this.selectedRecord);
        if (idx <= 0) {
            return;
        }
        var id = this.getRecordId(this.currentList[idx - 1]);
        this.changeSelectedRecord(id);
    };
    EditCardComponent.prototype.goNextRecord = function () {
        var idx = this.currentList.indexOf(this.selectedRecord);
        if (idx >= this.currentList.length - 1) {
            return;
        }
        var id = this.getRecordId(this.currentList[idx + 1]);
        this.changeSelectedRecord(id);
    };
    EditCardComponent.prototype.toggleAnchor = function (col) {
        if (this.disableEditing) {
            return;
        }
        col.isAnchored = !col.isAnchored;
        // if (col.isAnchored) {
        // 	this.updateListToAnchoredValue(col);
        // }
    };
    EditCardComponent.prototype.onMouseenterAnchor = function (col) {
        if (this.disableEditing) {
            return;
        }
        col.mouseoverAnchor = true;
    };
    EditCardComponent.prototype.onMouseleaveAnchor = function (col) {
        if (this.disableEditing) {
            return;
        }
        setTimeout(function () {
            col.mouseoverAnchor = false;
        }, 200);
    };
    EditCardComponent.prototype.updateListToAnchoredValue = function (col) {
        var _this = this;
        this.currentList.forEach(function (r) {
            if (r !== _this.selectedRecord) {
                r[col.prop] = _this.selectedRecord[col.prop];
                if (!r[_this.isEditedCol]) {
                    _this.mainDataService.addRecToCard(_this.getRecordId(r), null, 'card');
                }
                // r[col.prop] = this.selectedRecord[col.prop]
            }
        });
    };
    EditCardComponent.prototype.checkQcClass = function (col, type) {
        var qcClassByCol = this.selectedRecord[this.attrIndexService.cardQcClassColName];
        if (qcClassByCol && qcClassByCol[col.prop]) {
            switch (type) {
                case 'exception':
                    return qcClassByCol[col.prop] === 'qc-exception-cell';
                case 'warning':
                    return qcClassByCol[col.prop] === 'qc-warning-cell';
                case 'error':
                    return qcClassByCol[col.prop] === 'qc-error-cell';
            }
        }
    };
    EditCardComponent.prototype.checkFieldDirty = function (col) {
        var originAttrs = this.mainDataService.getDataOriginAttrs(this.getRecordId(this.selectedRecord));
        if (originAttrs) {
            return this.editService.hasValueChanged(this.selectedRecord[col.prop], originAttrs[col.prop]);
        }
    };
    EditCardComponent.prototype.onClickCarryAttr = function () {
        var _this = this;
        var onEnd = function () {
            _this.isCarryingAttr = false;
            if (_this.carryAttrToast) {
                _this.toastr.remove(_this.carryAttrToast.toastId);
                _this.carryAttrToast = null;
            }
        };
        if (this.isCarryingAttr) {
            this.mapService.endPickOnMap(this.mapService.map);
            onEnd();
        }
        else {
            this.carryAttrToast = this.toastr.info('Copy attributes from - Select source feature', null, {
                disableTimeOut: true
            });
            this.isCarryingAttr = true;
        }
        var layerNames = [this.mapLayerService.dataLayerName, this.mapLayerService.bgSurroundingsLayerName];
        this.mapService.startPickOnMap(this.mapService.map, layerNames, function (e) {
            var feat = e.feat;
            var attrs = _this.mainDataService.getDataAttrs(feat.getId());
            if (attrs) {
                var changedProps_1 = {};
                var layerCate_2 = _this.activityService.selectedLayerBS.getValue().layer.category;
                var cols = layerCate_2.standardCols;
                cols.forEach(function (c) {
                    if (c.isCarryRclCol) {
                        var propWithPrefix = layerCate_2.colPrefix + '_' + c.colName.toLowerCase();
                        changedProps_1[propWithPrefix] = attrs[propWithPrefix];
                    }
                });
                Object.keys(changedProps_1).forEach(function (key) { return _this.mainDataService.setDataAttrs(_this.getRecordId(_this.selectedRecord), key, changedProps_1[key]); });
            }
        }, function (e) {
            onEnd();
            _this.toastr.success('Copied!', null, {
                timeOut: 1000
            });
        });
    };
    EditCardComponent.prototype.addCard = function () {
        this.clickAdd.emit();
    };
    EditCardComponent.prototype.commit = function () {
        this.clickCommit.emit();
    };
    EditCardComponent.prototype.discard = function () {
        this.clickDiscard.emit();
    };
    EditCardComponent.prototype.changeDisplayMode = function (mode) {
        if (!mode) {
            mode = this.displayMode === 'selection' ? 'edit' : 'selection';
        }
        this.displayMode = mode;
        this.isEditedListCurrent = mode === 'edit';
        if (mode === 'edit') {
            this.currentList = this.editRecordList;
            if (this.editRecordList.indexOf(this.selectedRecord) === -1) {
                this.changeSelectedRecord(this.getRecordId(this.editRecordList[0]));
            }
        }
        else {
            this.currentList = this.selectionList;
            if (this.selectionList.indexOf(this.selectedRecord) === -1) {
                this.changeSelectedRecord(this.getRecordId(this.selectionList[0]));
            }
        }
    };
    EditCardComponent.prototype.checkCarryAttrTool = function () {
        this.showCarryAttrTool = this.selectedRecord && this.activityService.selectedLayerBS.getValue().layer && this.activityService.selectedLayerBS.getValue().layer.category.code === this.attrIndexService.cateCodeCenterline;
    };
    EditCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isInit = true;
        this.qcClassCol = this.attrIndexService.cardQcClassColName;
        this.isEditedCol = this.attrIndexService.isEditedKey;
        this.toDeleteCol = this.attrIndexService.isDeletedKey;
        this.isNewKey = this.attrIndexService.isNewDataKey;
        this.isIdOnlyKey = this.attrIndexService.isIdOnlyKey;
        this.nguidStandardCol = this.attrIndexService.nguidCol;
        this.changeDisplayMode('selection');
        this.dataIndexObjSub = this.mainDataService.dataIndexObjSubject.subscribe(function () {
            // const selectionList = []
            // this.selectionList.forEach(i => {
            // 	const rec = this.mainDataService.getDataAttrs(this.getRecordId(i));
            // 	if (rec) {
            // 		selectionList.push(rec);
            // 	}
            // })
            // const editList = [];
            // this.editRecordList.forEach(i => {
            // 	const rec = this.mainDataService.getDataAttrs(this.getRecordId(i));
            // 	if (rec) {
            // 		editList.push(rec);
            // 	}
            // })
            // this.currentList = this.currentList === this.selectionList ? selectionList : editList;
            // this.selectionList = selectionList;
            // this.editRecordList = editList;
            for (var i = 0; i < _this.selectionList.length; i++) {
                var rec = _this.mainDataService.getDataAttrs(_this.getRecordId(_this.selectionList[i]));
                if (rec) {
                    _this.selectionList[i] = rec;
                } // If rec doesn't exist, don't replace it, it will be replaced when dataIndex is populated
            }
            for (var i = 0; i < _this.editRecordList.length; i++) {
                var rec = _this.mainDataService.getDataAttrs(_this.getRecordId(_this.editRecordList[i]));
                if (rec) {
                    _this.editRecordList[i] = rec;
                }
            }
            if (_this.currentCardId) {
                _this.changeSelectedRecord(_this.currentCardId);
            }
        });
        this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(function (data) {
            _this.checkCarryAttrTool();
        });
        this.selectedRecordsSub = this.activityService.selectedRecordsBS.subscribe(function (data) {
            if (!data || !data.ids) {
                _this.selectionList = [];
                return;
            }
            _this.selectionList = data.ids.map(function (id) { return _this.mainDataService.getDataAttrs(id); });
            if (_this.currentList !== _this.selectionList) {
                _this.changeDisplayMode('selection');
            }
        });
        this.editListSub = this.activityService.editRecordListBS.subscribe(function (data) {
            if (!data || !data.ids) {
                _this.editRecordList = [];
                return;
            }
            _this.editRecordList = data.ids.map(function (id) { return _this.mainDataService.getDataAttrs(id); });
            if (!isInit && _this.currentList !== _this.editRecordList) {
                _this.changeDisplayMode('edit');
            }
        });
        this.currentCardSub = this.activityService.currentCardBS.subscribe(function (data) {
            if (!data || data.source === 'card') {
                return;
            }
            _this.changeSelectedRecord(data.id, true);
        });
        isInit = false;
        this.modelSub = this.mainDataService.modelBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.modelKey !== data) {
                    this.modelKey = data;
                }
                return [2 /*return*/];
            });
        }); });
    };
    EditCardComponent.prototype.ngOnDestroy = function () {
        this.dataIndexObjSub.unsubscribe();
        this.selectedLayerSub.unsubscribe();
        this.selectedRecordsSub.unsubscribe();
        this.editListSub.unsubscribe();
        this.currentCardSub.unsubscribe();
        this.modelSub.unsubscribe();
        // this.selectedRecordSub.unsubscribe();
    };
    EditCardComponent.prototype.ngOnChanges = function (changes) {
        // if (changes.currentCardId) { // && !changes.selectedRecord.firstChange
        // 	// if (this.selectedRecord) {
        // 	// 	this.selectedRecordOrigin = JSON.parse(JSON.stringify(this.selectedRecord));
        // 	// } else {
        // 	// 	this.selectedRecordOrigin = null;
        // 	// }
        // }
    };
    return EditCardComponent;
}());
export { EditCardComponent };
